import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import './popover.css'

class LeftNavigationLink extends Component {
  static propTypes = {
    route: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    children: PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.bool, PropTypes.element]),
    ).isRequired,
  }

  static defaultProps = {
    disabled: false,
  }

  constructor(props) {
    super(props)
    this.state = {
      showPopover: false,
    }
  }

  handleMouseEnter = () => {
    const { disabled } = this.props
    if (disabled) {
      this.setState({ showPopover: true })
    }
  }

  handleMouseLeave = () => {
    this.setState({ showPopover: false })
  }

  render() {
    const { route, children, disabled } = this.props
    const { showPopover } = this.state

    return (
      <li className={`nav-item ${disabled ? 'disabled' : ''}`}>
        <div
          className="emptyDiv"
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
        >
          <NavLink
            to={`/${route}`}
            activeClassName="isActive"
            className={`MenuItem ${route}`}
          >
            {children}
          </NavLink>
        </div>
        <div className={`textBox ${showPopover ? 'show' : ''}`}>
          <span>
            To gain access to this feature, please contact Rooster Grin
          </span>
        </div>
      </li>
    )
  }
}

export default LeftNavigationLink



// WEBPACK FOOTER //
// ./src/components/LeftMenu/LeftNavigationLink.js